export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En progreso"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Completado"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pendiente"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siguiente"])}
}